<template>
  <div class="wrapper">
    <button
      class="btn btn-primary btn-block"
      v-if="showAddBtn"
      @click="showProjectSearch"
    >
      + Connect task to project
    </button>
    <div class="project-input-wrapper" v-if="!showAddBtn">
      <div class="project-input" v-if="showProjectInput && !selectedProject">
        <input
          type="text"
          class="form-control"
          aria-label="Text input with dropdown button"
          placeholder="Search project..."
          v-model="searchProjectValue"
        />
      </div>
      <div class="project-select-btn" v-if="!selectedProject">
        <button
          class="btn btn-primary"
          @click="showProjectList = !showProjectList"
        >
          <i class="far fa-caret-square-down"></i>
        </button>
      </div>
      <div
        class="project-select-window"
        v-if="showProjectList && !selectedProject"
      >
        <ul
          class="list-group list-group-flush"
          v-if="projectsSearchResult.length < 1"
        >
          <li
            class="list-group-item"
            v-for="project in projects"
            :key="project.id"
            @click="selectProject(project)"
          >
            {{ project.project_title }}
          </li>
        </ul>
        <ul
          class="list-group list-group-flush"
          v-if="projectsSearchResult.length > 0"
        >
          <li
            class="list-group-item"
            v-for="project in projectsSearchResult"
            :key="project.id"
            @click="selectProject(project)"
          >
            {{ project.project_title }}
          </li>
        </ul>
      </div>
      <div
        class="selected-project"
        v-if="selectedProject"
        @click="[(selectedProject = null), (showProjectInput = true)]"
      >
        <span>Selected project: {{ selectedProject.project_title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "TaskProjectSelect",
  created() {
    // request to getting projects
    // this.projects = [
    //   { id: 1, title: "Google", startDate: "01/01/2012" },
    //   { id: 2, title: "Facebook", startDate: "03/03/2013" },
    //   { id: 3, title: "GMN", startDate: "04/04/2014" },
    //   { id: 4, title: "AMAZON", startDate: "02/06/2016" }
    // ];
    // this.fetchProjectList();
  },
  data() {
    return {
      projects: [],
      projectsSearchResult: [],
      selectedProject: null,
      searchProjectValue: "",
      showAddBtn: true,
      showProjectInput: false,
      showProjectList: false
    };
  },
  methods: {
    //Function gets list of projects(API request). Response is array of objects
    fetchProjectList() {
      // let path = "projects/list";
      // let apiClient = apiClientCreator(path);
      // apiClient.get("", {}).then(res => {
      //   return res;
      // });
    },
    //search function gets string updates projectsSearchResult array
    filterProjects(searchProjectValue) {
      this.projectsSearchResult = this.projects.filter(project => {
        searchProjectValue = searchProjectValue.trim();
        searchProjectValue = searchProjectValue.toLowerCase();
        let afterRegex = searchProjectValue.replace(
          /[.*+\-?^${}()|[\]\\]/g,
          ""
        );
        return project.project_title.toLowerCase().includes(afterRegex);
      });
    },
    // send emmit to add selected project
    selectProject(project) {
      this.selectedProject = project;
      this.$emit("selectProject", project.id);
    },
    showProjectSearch() {
      let path = "projects/list";
      let apiClient = apiClientCreator(path);
      apiClient.get("").then(res => {
        this.projects = res.data;
        this.showProjectInput = true;
        this.showAddBtn = false;
      });
    }
  },
  watch: {
    searchProjectValue() {
      this.filterProjects(this.searchProjectValue);
    }
  }
};
</script>

<style scoped>
.wrapper {
  margin: 20px;
}
.project-input-wrapper {
  display: flex;
  position: relative;
}
.project-input {
  flex: 6;
}
.project-select-btn {
  flex: 1;
}
.project-select-window {
  position: absolute;
  width: 100%;
  z-index: 1;
  top: 33px;
}
.project-input input {
  border-radius: 5px 0px 0px 5px;
}
.project-select-btn button {
  border-radius: 0px 5px 5px 0px;
}
.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: #efefef;
}
.selected-project {
  margin: 3px 10px;
  padding: 4px;
}
</style>
